import React, { Suspense, useEffect, useState } from "react";
import InvoiceStudioRevamp from "./prototype/InvoiceStudioRevamp";
import { PUBLIC_GUEST_MODE } from "./prototype/publicGuestMode";
import { isPasswordRecoveryLocation, capturePasswordRecoveryLink } from "./prototype/backend/passwordRecoveryLocation";
import "./App.css";
import "./styles/studio.css";

const LegacyHome = React.lazy(() =>
  import(/* webpackChunkName: "legacy-studio" */ "./pages/Home")
);

const MobileReceive = React.lazy(() =>
  import(/* webpackChunkName: "mobile-receive" */ "./pages/MobileReceive")
);

const PasswordRecovery = React.lazy(() => import(/* webpackChunkName: "password-recovery" */ "./prototype/features/PasswordRecoveryPage"));
const recoveryLink = typeof window !== "undefined" && isPasswordRecoveryLocation(window.location)
  ? capturePasswordRecoveryLink(window.location, window.history) : null;

const isReceiveHash = () =>
  !PUBLIC_GUEST_MODE &&
  typeof window !== "undefined" &&
  window.location.hash.replace(/^#/, "").startsWith("/receive");

const App = () => {
  // Hash route (works on any static host, no server rewrites): #/receive opens the
  // phone scanner; everything else is the app.
  const [view, setView] = useState(() => (isReceiveHash() ? "receive" : "home"));
  const [importedWorkspace, setImportedWorkspace] = useState(null);
  const showLegacy =
    !PUBLIC_GUEST_MODE &&
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("legacy");

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const onHashChange = () => setView(isReceiveHash() ? "receive" : "home");
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  if (recoveryLink) return <Suspense fallback={<main aria-busy="true">Loading account recovery...</main>}><PasswordRecovery capturedLink={recoveryLink} /></Suspense>;

  if (view === "receive") {
    return (
      <Suspense
        fallback={
          <main className="receive receive--loading" aria-busy="true">
            Loading scanner...
          </main>
        }
      >
        <MobileReceive
          onImported={(workspace) => {
            setImportedWorkspace(workspace);
            if (typeof window !== "undefined") {
              window.location.hash = "";
            }
            setView("home");
          }}
        />
      </Suspense>
    );
  }

  if (showLegacy) {
    return (
      <Suspense fallback={<main className="receive receive--loading">Loading workspace...</main>}>
        <LegacyHome importedWorkspace={importedWorkspace} />
      </Suspense>
    );
  }

  return <InvoiceStudioRevamp />;
};

export default App;
